import { render } from "./QuestionSeven.vue?vue&type=template&id=2a188d2b"
import script from "./QuestionSeven.vue?vue&type=script&lang=js"
export * from "./QuestionSeven.vue?vue&type=script&lang=js"

import "./QuestionSeven.vue?vue&type=style&index=0&id=2a188d2b&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__